import Vue from 'vue'
import VueRouter from 'vue-router'
import ChooseSystem from '../views/ChooseSystem.vue'

Vue.use(VueRouter)

const routes = [
	{
		name: 'ChooseSystem',
		path: '/',
		component: ChooseSystem
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
